const Error = () => (
    <svg
        width='158'
        height='158'
        viewBox='0 0 158 158'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M73.8038 9C76.1133 5 81.8867 5 84.1962 9L142.22 109.5C144.529 113.5 141.643 118.5 137.024 118.5H20.9763C16.3575 118.5 13.4707 113.5 15.7801 109.5L73.8038 9Z'
            fill='#F15266'
        />
        <rect x='74.5' y='41.5' width='9' height='44' rx='4.5' stroke='white' />
        <rect x='74.5' y='92.5' width='9' height='9' rx='4.5' stroke='white' />
    </svg>
);

export default Error;
